import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import * as coreStore from '@core';
import * as identityStore from '@core/identity';
import { select, Store } from '@ngrx/store';

@Directive({
  selector: '[ifRoles]',
  standalone: true,
})
export class IfRolesDirective implements OnInit {
  // the role the user must have
  @Input() public ifRoles: string[] = [];

  // check if view is already created
  private viewCreated = false;

  /**
   * @param {ViewContainerRef} viewContainerRef -- the location where we need to render the templateRef
   * @param {TemplateRef<any>} templateRef -- the templateRef to be potentially rendered
   * @param {RolesService} rolesService -- will give us access to the roles a user has
   */
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private store: Store
  ) {}

  public ngOnInit(): void {
    this.store
      .pipe(select(identityStore.selectIdentityAccount(coreStore.selectIdentityState)))
      .subscribe(account => {
        const userRoles = account?.idTokenClaims?.roles;

        if (!userRoles) {
          // Remove element from DOM
          this.viewContainerRef.clear();
          return;
        }

        const matchingRoles = userRoles.filter(x => this.ifRoles?.includes(x));

        if (!this.viewCreated && (matchingRoles.length > 0 || this.ifRoles.length === 0)) {
          // appends the ref element to DOM
          this.viewContainerRef.createEmbeddedView(this.templateRef);
          this.viewCreated = true;
        } else if (!this.viewCreated) {
          this.viewContainerRef.clear();
        }
      });
  }
}
